<template>
  <div>
    <back-button route='/Pakbonnen'>Alle pakbonnen</back-button>

    <div class="md-layout md-gutter md-alignment-top-left">

      <prop-card class="md-layout-item" :data="itemVm" :header="item != null ? item.No : ''" />

      <md-table v-if="item != null && item.Lines.length > 0" v-model="item.Lines" class="md-layout-item" md-card>
        <md-table-toolbar>
          <h1 class="md-title">Pakbon regels</h1>
        </md-table-toolbar>

        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="Nr.">{{ item.No }}</md-table-cell>
          <md-table-cell md-label="Omschrijving">{{ item.Description }}</md-table-cell>
          <md-table-cell md-label="Aantal">{{ item.Quantity }}</md-table-cell>
          <md-table-cell md-label="Eenheidscode">{{ item.Unit_of_Measure_Code }}</md-table-cell>
        </md-table-row>
      </md-table>

      <download-pdf class="md-layout-item" :downloading="downloading" @click="download" />
    </div>
  </div>
</template>

<script>
  import Api from '@/api';
  import { Events } from '@wsb/wsb-jsbase';
  import PC from '@/components/PropCard';
  import BB from '@/components/BackButton';
  import DP from '@/components/DownloadPdf';
  import Format from '@/format';

  export default {
    name: 'Pakbon',
    props: ['id'],
    created: function() {
      this.item.Nr = this.id;
    },
    data: () => ({
      item: null,
      downloading: false
    }),
    computed: {
      itemVm: function () {
        if (this.item !== null) {
          var obj = {
            'Nr.': this.item.No,
            'Factuuradres': `${this.item.Bill_to_Name}\n${this.item.Bill_to_Address}\n${this.item.Bill_to_Post_Code}, ${this.item.Bill_to_City}`,
            'Verzenddatum': Format.date(this.item.Posting_Date),
          };
          const verz = `${this.item.Ship_to_Name}\n${this.item.Ship_to_Address}\n${this.item.Ship_to_Post_Code}, ${this.item.Ship_to_City}`;
          if (verz != obj['Factuuradres']) {
            obj['Verzendadres'] = verz;
          }
          if (this.item.Order_No) { obj['Ordernummer'] = this.item.Order_No; }
/////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////
          if (this.item.External_Document_No != '') { obj['Extern documentnr.'] = this.item.External_Document_No; }
          return obj;
        } else {
          return null;
        }
      }
    },
    methods: {
      load() {
        Api.Get(`/odata/PostedSalesShipment('${this.id}')?$expand=Lines`, ['Posting_Date'])
          .then(r => {
            r.Lines = r.Lines.map(i => i.No !== '' ? i : { Description: i.Description });
            this.item = r;
          })
          .catch(Events.RaiseExceptionOccurred);
      },
      download() {
        this.downloading = true;
        Api.DownloadFile(`/Report/Shipment/${this.id}`, `Pakbon_${this.id}.pdf`)
          .then(() => { this.downloading = false; })
          .catch(e => {
            this.downloading = false;
            Events.RaiseExceptionOccurred(e);
          });
      }
    },
    created() {
      this.load();
    },
    components: {
      'prop-card': PC,
      'back-button': BB,
      'download-pdf': DP
    }
  };
</script>

<style scoped>
  td {
    padding: 4pt;
  }
  .tdMain {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Pakbon.vue